import { FC, ReactNode } from 'react'
import Divider from '@/components/divider'
import { useDropdownContext } from '../../hooks'
import { ContainerDropdownHeader } from './ContainerDropdownHeader'
import { MdOutlineChevronLeft, MdOutlineClose } from 'react-icons/md'

export interface DropdownHeaderProps {
  children?: ReactNode
  title?: string
  showCloseButton?: boolean
  className?: string
  showLeftChevron?: boolean
  onClickInArrow?: () => void
  showDivider?: boolean
}

export const _DropdownHeader: FC<DropdownHeaderProps> = ({
  children,
  title,
  className,
  showCloseButton,
  showLeftChevron,
  onClickInArrow,
  showDivider
}) => {
  const { onClose, setIsOpen } = useDropdownContext()

  const handleOnClose = () => {
    onClose?.()
    setIsOpen?.(false)
  }

  if (children) {
    return (
      <ContainerDropdownHeader className={className}>
        {children}
      </ContainerDropdownHeader>
    )
  }

  return (
    <>
      <ContainerDropdownHeader className={className}>
        <div className="flex flex-row items-center justify-between">
          {showLeftChevron && (
            <button
              type="button"
              data-testid="button-left"
              onClick={onClickInArrow}
            >
              <MdOutlineChevronLeft className="text-primary min-w-[24px] min-h-[24px]" />
            </button>
          )}
          <p className="text-body-bold-l text-primary">{title}</p>
          {showCloseButton && (
            <button
              type="button"
              data-testid="button-close"
              onClick={handleOnClose}
            >
              <MdOutlineClose className="text-primary min-w-[24px] min-h-[24px]" />
            </button>
          )}
        </div>
      </ContainerDropdownHeader>
      {showDivider && <Divider />}
    </>
  )
}
